import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const LABELS = [["items", "articoli"], ["devices", "apparati con matricola"], ["serials", "matricole (anche installate)"], ["stock", "giacenze"],
  ["stock_movements", "movimenti"], ["item_prices", "storico prezzi"], ["stock_receipts", "carichi merce"], ["van_refills", "reintegri furgoni"], ["stock_counts", "inventari"]];

export const WarehouseWipe = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [c, setC] = useState(null);
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setOpen(true); setWord(""); setC(null);
    try { setC((await api.get("/warehouse/wipe/preview")).data); } catch (e) { toast.error(errMsg(e)); }
  };
  const run = async () => {
    setBusy(true);
    try { await api.post("/warehouse/wipe", { confirm: word }); toast.success("Magazzino svuotato"); setOpen(false); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" className="text-red-700" onClick={start} data-testid="warehouse-wipe-open"><Trash2 className="mr-2 h-4 w-4" />Svuota magazzino</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle className="font-display text-2xl">Svuota magazzino</DialogTitle></DialogHeader>
          <p className="text-sm">Verranno cancellati <b>definitivamente</b>:</p>
          {c && <ul className="space-y-0.5 text-sm text-red-700" data-testid="warehouse-wipe-summary">{LABELS.map(([k, l]) => <li key={k}><b>{c[k]}</b> {l}</li>)}</ul>}
          <p className="text-sm text-muted-foreground">Magazzini, furgoni, DDT e ordini di lavoro restano. Poi potrai caricare il nuovo elenco articoli e apparati.</p>
          <Input value={word} onChange={(e) => setWord(e.target.value)} placeholder="Scrivi SVUOTA per confermare" data-testid="warehouse-wipe-confirm-input" />
          <DialogFooter><Button variant="destructive" disabled={busy || !c || word.trim().toUpperCase() !== "SVUOTA"} onClick={run} data-testid="warehouse-wipe-run">Svuota definitivamente</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
